import { FC } from "react";
import {
  AspectRatio,
  Box,
  Button,
  Card,
  Chip,
  Stack,
  Typography,
} from "@mui/joy";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useColorScheme } from "@mui/joy/styles";

import DarkImage from "src/assets/images/My-Profile.png";
import LightImage from "src/assets/images/my-image.jpg";

const Home: FC = () => {
  const { t } = useTranslation();
  const { mode } = useColorScheme();
  const isDark = mode !== "light";

  return (
    <Box
      sx={{
        minHeight: { xs: "calc(100dvh - 140px)", md: "calc(100dvh - 80px)" },
        display: "grid",
        placeItems: "center",
        py: { xs: 4, md: 7 },
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1.15fr 0.85fr" },
          gap: { xs: 5, md: 8 },
          alignItems: "center",
        }}
      >
        <Stack spacing={3.2} sx={{ order: { xs: 2, md: 1 } }}>
          <Chip
            color="primary"
            variant="soft"
            size="lg"
            sx={{
              width: "fit-content",
              borderRadius: "999px",
              fontWeight: 800,
            }}
          >
            {t("homeAbout.title.job")}
          </Chip>

          <Stack spacing={1.4}>
            <Typography level="h1">
              {t("homeAbout.title.hello")}{" "}
              <Box component="span" sx={{ color: "primary.500" }}>
                {t("homeAbout.title.name")}
              </Box>
              {" " + t("homeAbout.title.is")}
            </Typography>

            <Typography
              level="h3"
              sx={{ color: "text.secondary", fontWeight: 650 }}
            >
              {t("homeAbout.title.job")}
            </Typography>
          </Stack>

          <Typography
            level="body-lg"
            sx={{ color: "text.tertiary", maxWidth: 680 }}
          >
            {t("homeAbout.text")}
          </Typography>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            <Button
              component={Link as any}
              to="/about"
              size="lg"
              sx={{ px: 4 }}
            >
              {t("moreAboutMe")}
            </Button>
            <Button
              component={Link as any}
              to="/portfolio"
              size="lg"
              color="neutral"
              variant="outlined"
              sx={{ px: 4 }}
            >
              {t("portfolio")}
            </Button>
          </Stack>
        </Stack>

        <Box sx={{ order: { xs: 1, md: 2 }, position: "relative" }}>
          <Box
            sx={{
              position: "absolute",
              inset: { xs: 8, md: -18 },
              borderRadius: "40px",
              background:
                "linear-gradient(135deg, var(--joy-palette-primary-500), transparent 62%)",
              opacity: 0.34,
              filter: "blur(24px)",
            }}
          />

          <Card
            variant="outlined"
            sx={{
              position: "relative",
              p: 1.2,
              maxWidth: 430,
              mx: "auto",
              borderRadius: "34px",
              bgcolor: "background.surface",
              backdropFilter: "blur(16px)",
              boxShadow: "lg",
            }}
          >
            <AspectRatio
              ratio="4/5"
              sx={{ borderRadius: "28px", overflow: "hidden" }}
            >
              <img src={isDark ? DarkImage : LightImage} alt="profile" />
            </AspectRatio>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
